// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-recordStyles___editRecordPaper--dMr7D {
  min-width: 400px;
  min-height: 400px;
  padding: 20px;
}

.components-CompanyDetails-recordStyles___fieldRow--BLvJU {
  margin-bottom: 16px;
}

.components-CompanyDetails-recordStyles___editFieldWrapper--Nydhz {
  margin-top: 8px;
}

.components-CompanyDetails-recordStyles___clickableRow--QbLDr {
  cursor: pointer;
}

.components-CompanyDetails-recordStyles___emptyMessage--IWO3g {
  padding: 24px;
  text-align: center;
  color: #6d717a;
  font-size: 15px;
}

.components-CompanyDetails-recordStyles___bulkActionBar--HSGO7 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 8px;
}

.components-CompanyDetails-recordStyles___bulkSelectionCount--y9xJN {
  font-size: 14px;
  color: #1b2432;
  font-family: 'Roboto-Medium', 'Roboto';
  font-weight: 500;
  margin-right: 4px;
}

.components-CompanyDetails-recordStyles___bulkActionButton--qnBB3 {
  padding: 6px 16px;
  font-size: 14px;
  font-family: 'Roboto-Medium', 'Roboto';
  font-weight: 500;
  border: 1px solid rgba(49, 138, 251, 0.5);
  border-radius: 4px;
  background: transparent;
  color: #318afb;
  cursor: pointer;
}

.components-CompanyDetails-recordStyles___bulkActionButton--qnBB3:hover {
    background-color: rgba(49, 138, 251, 0.08);
  }

.components-CompanyDetails-recordStyles___bulkActionButton--qnBB3:disabled {
    opacity: 0.4;
    cursor: default;
  }

.components-CompanyDetails-recordStyles___bulkActionButtonError--qim6R {
  color: #d32f2f;
  border-color: rgba(211, 47, 47, 0.5);
}

.components-CompanyDetails-recordStyles___bulkActionButtonError--qim6R:hover {
    background-color: rgba(211, 47, 47, 0.08);
  }
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/recordStyles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AAUjB;;AARE;IACE,0CAA0C;EAC5C;;AAEA;IACE,YAAY;IACZ,eAAe;EACjB;;AAGF;EACE,cAAc;EACd,oCAAoC;AAKtC;;AAHE;IACE,yCAAyC;EAC3C","sourcesContent":[".editRecordPaper {\n  min-width: 400px;\n  min-height: 400px;\n  padding: 20px;\n}\n\n.fieldRow {\n  margin-bottom: 16px;\n}\n\n.editFieldWrapper {\n  margin-top: 8px;\n}\n\n.clickableRow {\n  cursor: pointer;\n}\n\n.emptyMessage {\n  padding: 24px;\n  text-align: center;\n  color: #6d717a;\n  font-size: 15px;\n}\n\n.bulkActionBar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  background-color: #f5f7fa;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.bulkSelectionCount {\n  font-size: 14px;\n  color: #1b2432;\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-weight: 500;\n  margin-right: 4px;\n}\n\n.bulkActionButton {\n  padding: 6px 16px;\n  font-size: 14px;\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-weight: 500;\n  border: 1px solid rgba(49, 138, 251, 0.5);\n  border-radius: 4px;\n  background: transparent;\n  color: #318afb;\n  cursor: pointer;\n\n  &:hover {\n    background-color: rgba(49, 138, 251, 0.08);\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: default;\n  }\n}\n\n.bulkActionButtonError {\n  color: #d32f2f;\n  border-color: rgba(211, 47, 47, 0.5);\n\n  &:hover {\n    background-color: rgba(211, 47, 47, 0.08);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editRecordPaper": `components-CompanyDetails-recordStyles___editRecordPaper--dMr7D`,
	"fieldRow": `components-CompanyDetails-recordStyles___fieldRow--BLvJU`,
	"editFieldWrapper": `components-CompanyDetails-recordStyles___editFieldWrapper--Nydhz`,
	"clickableRow": `components-CompanyDetails-recordStyles___clickableRow--QbLDr`,
	"emptyMessage": `components-CompanyDetails-recordStyles___emptyMessage--IWO3g`,
	"bulkActionBar": `components-CompanyDetails-recordStyles___bulkActionBar--HSGO7`,
	"bulkSelectionCount": `components-CompanyDetails-recordStyles___bulkSelectionCount--y9xJN`,
	"bulkActionButton": `components-CompanyDetails-recordStyles___bulkActionButton--qnBB3`,
	"bulkActionButtonError": `components-CompanyDetails-recordStyles___bulkActionButtonError--qim6R`
};
module.exports = ___CSS_LOADER_EXPORT___;
